import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import classNames from 'classnames';
import Icon, { Size } from '@jetbrains/ring-ui/components/icon';
import appLogo from '@jetbrains/logos/jetbrains-ide-services/jetbrains-ide-services-particle.svg';
import appLogoFull from '@jetbrains/logos/jetbrains-ide-services/jetbrains-ide-services-white.svg';
import styles from './ide-services-logo.css';
export function IdeServicesLogo(props) {
    const { className, size = Size.Size32, collapsible } = props;
    return (_jsxs("div", { style: toCssProperties(size), className: classNames(styles.wrapper, className, { [styles.collapsible]: collapsible }), children: [_jsx(Icon, { className: classNames(styles.logoSmall, styles.icon), glyph: appLogo }), _jsx(Icon, { className: classNames(styles.logoText, styles.icon), glyph: appLogoFull })] }));
}
function toCssProperties(size) {
    return { '--logo-size': `${size}px` };
}
